import type { Post } from '@/domain/content'
import { filesystemSource } from './adapters/filesystemSource'

export const getAllNotes = () => filesystemSource.getAllNotes()
export const getAllCaseStudies = () => filesystemSource.getAllCaseStudies()
export const getContentBySlug = (type: Post['type'], slug: string) =>
  filesystemSource.getContentBySlug(type, slug)
